export default __webpack_public_path__ + "static/media/ic_product-category.d7d2b225.svg";